export function debounce(func, wait, immediate = false) {
    let timeout;
    return function (...args) {
        const later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(this, args);
            }
        }.bind(this);
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(this, args);
        }
    };
}
export const isRTL = () => document.documentElement.dir === "rtl";
/*  This functions overrides a method adding calls before (`before()`) and
    after (`after()`)
*/
export function overrideMethod(component, methodName, { before, after }) {
    const oldMethod = component[methodName];
    component[methodName] = () => {
        if (before !== undefined) {
            before();
        }
        if (oldMethod !== undefined) {
            oldMethod.call(component);
        }
        if (after !== undefined) {
            after();
        }
    };
}
/**
 * Converts an object mapping token keys to booleans into a space-separated
 * string containing the token keys that map to truthy values.
 */
export const tokenMap = (tokens) => Object.keys(tokens)
    .filter(key => tokens[key])
    .join(" ");
/**
 * `true` if `x` <= `y` <= `z`
 */
export const inBetween = (x, y, z) => x <= y && y <= z;
const resetDragImage = new Image();
export const removeDragImage = (event) => event.dataTransfer.setDragImage(resetDragImage, 0, 0);
//# sourceMappingURL=utils.js.map
